import AjaxUtils from "../util/ajax-utils";

const $ = require('jquery');

export default class SustainabilityCalculator {

    constructor(root)
    {
        this.container = root;
        this.moreLinks = [];
        this.filePickers = this.container.querySelectorAll('.file-picker');
        this.filePickerObjects = [];
        this.projectSectionInputs = this.container.querySelectorAll('.calculator__project__input');
        this.cumulativeInputs = this.container.querySelectorAll('.accordion-module__general-module input');
        this.someCumulativeInputsFilled = false;
        this.someProjectSectionInputsFilled = false;
        this.calculateClicks = 0;
        this.calculateClicksWithProjectAndCumulativeInputs = 0;

        this.handleSubmit();
        this.handleErrorClear();
        this.registerListeners();

        $('.stats-module-single ul').addClass('stats-module--result');

    }

    handleProjectSectionInputChanged() {
        this.someProjectSectionInputsFilled = [...this.projectSectionInputs].some(input => input.value !== '');
        this.toggleProjectSectionInputsRequired(this.areProjectSectionInputsRequired());
    }

    handleCumulativeInputChanged() {
        this.someCumulativeInputsFilled = [...this.cumulativeInputs].some(input => input.value > 0);
        this.toggleProjectSectionInputsRequired(this.areProjectSectionInputsRequired());
    }

    areProjectSectionInputsRequired() {
        // project inputs required unless some cumulative inputs are filled and no project section inputs are filled
        return this.someProjectSectionInputsFilled || !(this.someCumulativeInputsFilled && !this.someProjectSectionInputsFilled) || !this.someCumulativeInputsFilled;
    }

    toggleProjectSectionInputsRequired(isRequired) {
        this.projectSectionInputs.forEach((input) => {
            input.required = isRequired;
        });
    }

    handleErrorClear()
    {
      // Remove the error class if values are changed
        $('select').change(function () {
            $(this).removeClass('error');
        });
        $('input').on('keyup', function () {
            $(this).removeClass('error');
        });
    }

    handleProjectSectionInputsErrorClear() {
        if (this.areProjectSectionInputsRequired()) {
            this.projectSectionInputs.forEach((input) => {
                $(input).removeClass('error');
            });
        }
    }

    handleSubmit()
    {
        var that = this;
        $('#calculate').click(function (e) {
            e.preventDefault();
            // Check fields are filled
            if(that.handleError()) {
                return;
            }
            // Remove existing hidden inputs
            $('.calc-input').remove();

            // Get values from form fields
            const projectName = $('input#project-name').val();
            const averageName = $('#average_name').val();
            const product = $('select#product').find(':selected').val() === 'average' ? averageName : $('select#product').find(':selected').text();
            const roofingSquares = $('input#quantity').val() > 0 ? $('input#quantity').val() : 0;

            // Get values from cumulative inputs & calculate the cumulative stats
            let cumulativeStatsArr = { cumulative: [0,0,0]};
            that.cumulativeInputs.length > 0 && $(that.cumulativeInputs).each(function() {
                const roofingSquares = $(this).val();
                const bottles = $(this).data('bottles');
                const tires = $(this).data('tires');
                const trees = $(this).data('trees');
                const stats = that.calculateStats(bottles, tires, trees, roofingSquares);
                cumulativeStatsArr.cumulative[0] += Number(stats.bottleCalc);
                cumulativeStatsArr.cumulative[1] += Number(stats.tireCalc);
                cumulativeStatsArr.cumulative[2] += Number(stats.treeCalc);
            });
            cumulativeStatsArr.cumulative[0] = that.abbreviateNumber(cumulativeStatsArr.cumulative[0]);
            cumulativeStatsArr.cumulative[1] = that.abbreviateNumber(cumulativeStatsArr.cumulative[1]);
            cumulativeStatsArr.cumulative[2] = that.abbreviateNumber(cumulativeStatsArr.cumulative[2]);


            if (that.calculateClicks > 0) {
                const firstStatsModuleList = $('.stats-module-single ul').first();
                // Remove results-text and button from stats module
                firstStatsModuleList.find('.results-text').remove();
                firstStatsModuleList.find('.cumulative-results').remove();
                firstStatsModuleList.find('.pdf-download').remove();
                firstStatsModuleList.find('.filetype-selector-container').remove();
            }




          // Get values from select option and calculate stats
            const selected = $('select#product').find(':selected');
            const bottles = selected.data('bottles');
            const tires = selected.data('tires');
            const trees = selected.data('trees');
            let stats = that.calculateStats(bottles, tires, trees, roofingSquares);
            // abbreviate the stats
            stats.bottleCalc = that.abbreviateNumber(stats.bottleCalc);
            stats.tireCalc = that.abbreviateNumber(stats.tireCalc);
            stats.treeCalc = that.abbreviateNumber(stats.treeCalc);

            const allStatsArr = {...cumulativeStatsArr, ...stats};

            if (that.someProjectSectionInputsFilled && that.someCumulativeInputsFilled) that.calculateClicksWithProjectAndCumulativeInputs++;

            that.populateStatsModule(product, projectName, roofingSquares, allStatsArr);

            that.pdfButton(product, allStatsArr);
            that.calculateClicks++;
        });
    }

    shouldCloneULForCumulativeStats() {
        return (this.calculateClicksWithProjectAndCumulativeInputs === 1);
    }

    statsHasBeenCloned() {
        return $('.stats-module-single ul').length > 1;
    }

    populateStatsModule(product, projectName, roofingSquares, allStatsArr = null) {

        const targetStatsUL = $('.stats-module-single ul').first();
        if (this.areProjectSectionInputsRequired()) {
            let resultsElement =
                `<p class="results-text p1" style="display: none">
                    Results for <strong>${roofingSquares} Squares</strong> of <strong>${product}</strong> Shingles for <strong>${projectName}</strong>
                </p>`;
            targetStatsUL.prepend(resultsElement);
            targetStatsUL.find('.results-text').slideDown();

            const bottlesStatContainer = targetStatsUL.find('.statistic .text .figure').eq(1);
            bottlesStatContainer.text(allStatsArr.bottleCalc).slideDown();

            const tiresStatContainer = targetStatsUL.find('.statistic .text .figure').first();
            tiresStatContainer.text(allStatsArr.tireCalc).slideDown();

            const treesStatContainer = targetStatsUL.find('.statistic .text .figure').eq(2);
            treesStatContainer.text(allStatsArr.treeCalc).slideDown();
        }

        let cumulativeStatsModule;

        if (this.someCumulativeInputsFilled) {
            const cumulativeResultsElement = `<p class="results-text cumulative-results p1">Results for your<strong> Cumulative Eco-Offset</strong></p>`;

            // One stats mod exists on land. If there's no project inputs filled, we use the existing one for cumulative stats.
            // If there are project input filled, we clone the existing one and add the cumulative stats to the new one.
            // Only clone once so there isn't repeated cumulative stats mods.
            if (this.shouldCloneULForCumulativeStats()) {
                cumulativeStatsModule = targetStatsUL.clone();
                cumulativeStatsModule.insertAfter(targetStatsUL);
                cumulativeStatsModule.prepend(cumulativeResultsElement);
            } else if (this.statsHasBeenCloned()) {
                cumulativeStatsModule = $('.stats-module-single ul:eq(1)');
            } else {
                cumulativeStatsModule = $('.stats-module-single ul').first();
                // When only one stats mod exist in handleSubmit() this will get removed from the first stats mod and added again on each submit.
                // When cloning, it's added to the new stats mod one time only.
                cumulativeStatsModule.prepend(cumulativeResultsElement);
            }


            const cumulativeBottlesStatContainer = cumulativeStatsModule.find('.statistic .text .figure').eq(1);
            cumulativeBottlesStatContainer.text(allStatsArr.cumulative[0]).slideDown();

            const cumulativeTiresStatContainer = cumulativeStatsModule.find('.statistic .text .figure').first();
            cumulativeTiresStatContainer.text(allStatsArr.cumulative[1]).slideDown();

            const cumulativeTreesStatContainer = cumulativeStatsModule.find('.statistic .text .figure').eq(2);
            cumulativeTreesStatContainer.text(allStatsArr.cumulative[2]).slideDown();
        }
    }

    calculateStats(bottles, tires, trees, roofingSquares)
    {
      // Calculation made based on 'formula spreadsheet' in Functional Spec which specifies savings per 30 squares
      // So we divide the item by 30, to get item per 1 square and multiply by the number of squares entered by the user
        let bottleCalc = ((bottles / 30) * roofingSquares).toFixed(0);
        let tireCalc = ((tires / 30) * roofingSquares).toFixed(0);
        let treeCalc = ((trees / 30) * roofingSquares).toFixed(0);

        return {bottleCalc, tireCalc, treeCalc};
    }
    abbreviateNumber(value)
    {
        var newValue = value;
        if (value >= 1000) {
            var suffixes = ["", "K", "M", "B","T"];
            var suffixNum = Math.floor((""+value).length/3);
            var shortValue = '';
            for (var precision = 2; precision >= 1; precision--) {
                shortValue = parseFloat((suffixNum != 0 ? (value / Math.pow(1000,suffixNum) ) : value).toPrecision(precision));
                var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
                if (dotLessShortValue.length <= 2) {
                    break; }
            }
            if (shortValue % 1 != 0) {
                shortValue = shortValue.toFixed(1);
            }
            newValue = shortValue+suffixes[suffixNum];
        }
        return newValue;
    }

    pdfButton(product, calcArr)
    {
        // Remove existing pdf button
        $('.pdf-download').remove();

        const statsModSingle = $('.stats-module-single').first();
        const statsModSingleLastChild = statsModSingle.children().last();
        const statsModSingleList = $('.stats-module-single ul');
        const calculateForm = $('.calculator__form form');

        const hiddenInputs = `
            <input type="hidden" class="calc-input" name="product-name" value="${product}">
            <input type="hidden" class="calc-input" name="tires" value="${calcArr.tireCalc}">
            <input type="hidden" class="calc-input" name="bottles" value="${calcArr.bottleCalc}">
            <input type="hidden" class="calc-input" name="trees" value="${calcArr.treeCalc}">
            <input type="hidden" class="calc-input" name="tally_bottles" value="${calcArr.cumulative[0]}">
            <input type="hidden" class="calc-input" name="tally_tires" value="${calcArr.cumulative[1]}">
            <input type="hidden" class="calc-input" name="tally_trees" value="${calcArr.cumulative[2]}">`;

        const downloadButton = $(`
            <button type="submit" id="calculate" class="pdf-download button orange-outline">
                Generate Eco Certificates and Social Media Posts
            </button>`);

        calculateForm.append(hiddenInputs);
        if (this.someCumulativeInputsFilled) {
            statsModSingleList.each(function() {
                $(this).addClass('results');
            });
        } else {
            statsModSingleList.first().addClass('results');
        }
        downloadButton.insertBefore(statsModSingleLastChild);
        statsModSingle.find('.pdf-download').on('click', function () {
            calculateForm.submit();
        });

        $('.pdf-download').show();

    }

    handleError()
    {
        if (!this.areProjectSectionInputsRequired()) {
            return false;
        }
        let hasError = false;
        if ($('select#product').find(':selected').val() === "") {
            $('select#product').addClass('error');
            hasError = true;
        }
        if (!$('input#quantity').val()) {
            $('input#quantity').addClass('error');
            hasError = true;
        }
        if (!$('input#project-name').val()) {
            $('input#project-name').addClass('error');
            hasError = true;
        }
        return hasError;
    }

    dispatchEvent(event, detail)
    {
        const e = detail ? new CustomEvent(event, {
            detail: detail
        }) : new Event(event);
        this.container.dispatchEvent(e);
    }

    toggleError(container, show, message, isInvalidFile) {
        if (show) {
            container.classList.add('error');
            if (message) {
                console.error(message);
            }
        } else {
            container.classList.remove('error');
        }
    }

    handleDrop(e, _this, filePickerObj) {
        _this.handleDragExit(e, filePickerObj);

        if (e.dataTransfer.items) {
            if (e.dataTransfer.items.length > 0 && e.dataTransfer.items[0].kind === 'file') {
                let files = [];
                for(const item of e.dataTransfer.items) {
                    if(item.kind === 'file') {
                        files.push(item.getAsFile());
                        filePickerObj.filesArr.push(item.getAsFile());
                    }
                }
                _this.handleFileReceived(files, filePickerObj);
            }
        } else if(e.dataTransfer.files.length > 0) {
            _this.handleFileReceived(e.dataTransfer.files, filePickerObj);
        }
    }

    handleDragOver(e, filePickerObj) {
        e.preventDefault();
        filePickerObj.dropZone.classList.add('form-emerald-pro__dropzone__over');
    }

    handleDragExit(e, filePickerObj) {
        e.preventDefault();
        filePickerObj.dropZone.classList.remove('form-emerald-pro__dropzone__over');
    }

    renderFileConfirm(filePickerObj) {
        this.updateFileUploadError(filePickerObj.filesArr, filePickerObj);
        filePickerObj.uploadConfirmContainer.innerHTML = "";
        
        if (filePickerObj.filesArr.length > 0) {
            filePickerObj.filesArr.forEach(f => {
                filePickerObj.uploadConfirmContainer.appendChild(this.getConfirmLine(f, filePickerObj));
            });
        } else {
            filePickerObj.dropZone.classList.remove('hide');
        }
    }

    getConfirmLine(file, filePickerObj) {
        const node = document.createElement('div');
        node.classList.add('upload-confirm');
        node.classList.add('visible');
        node.innerHTML = `<p class="filename p3 bold">${file.name}</p>
                        <button class="trash-button">
                            <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.1005 15H3.87607C3.11641 15 2.51953 14.4031 2.51953 13.6435V3.3338H14.4571V13.6435C14.4571 14.4031 13.8602 15 13.1005 15Z" stroke="#D28122" stroke-miterlimit="10"/>
                                <path d="M5.61133 7.13141V11.201" stroke="#D28122" stroke-miterlimit="10" stroke-linecap="round"/>
                                <path d="M11.3086 7.13141V11.201" stroke="#D28122" stroke-miterlimit="10" stroke-linecap="round"/>
                                <path d="M8.48828 6.15521V12.124" stroke="#D28122" stroke-miterlimit="10" stroke-linecap="round"/>
                                <path d="M1 3.3338H15.9219" stroke="#D28122" stroke-miterlimit="10" stroke-linecap="round"/>
                                <path d="M10.3887 1H6.59041C6.0478 1 5.66797 1.43409 5.66797 1.92245V3.27898H11.3112V1.92245C11.3112 1.43409 10.9313 1 10.3887 1Z" stroke="#D28122" stroke-miterlimit="10" stroke-linecap="round"/>
                            </svg>
                        </button>`;

        node.querySelector('button.trash-button').addEventListener('click', () => {
            this.handleDeleteFile(file, filePickerObj);
        });
        return node;
    }

    handleFileReceived(files, filePickerObj) {
        this.updateFileUploadError(files, filePickerObj);

        const dt = new DataTransfer();
        let totalSize = 0;

        Array.from(files).forEach(file => {
            const isValid = (file.type === "image/jpeg" || file.type === "image/png");
            totalSize += file.size;

            if (totalSize > AjaxUtils.MAX_UPLOAD_SIZE) {
                console.error(`Total file upload must not exceed ${AjaxUtils.MAX_UPLOAD_SIZE_MB} MB. Current upload: ${(totalSize / 1048576).toFixed(1)} MB`);
                this.toggleError(filePickerObj.fileDropContainer, true, `Total file upload must not exceed ${AjaxUtils.MAX_UPLOAD_SIZE_MB} MB. Current upload: ${(totalSize / 1048576).toFixed(1)} MB`, false);
                return;
            }

            if (isValid) {
                dt.items.add(file);
                filePickerObj.filesArr.push(file);
            } else {
                this.toggleError(filePickerObj.fileDropContainer, true, "Invalid file type. Please upload a JPG or PNG file.", true);
                return;
            }
        });

        if (dt.files.length > 0) {
            filePickerObj.filePicker.files = dt.files;
            filePickerObj.dropZone.classList.add('hide');
            this.renderFileConfirm(filePickerObj);
        }
    }

    handleDeleteFile(file, filePickerObj) {
        filePickerObj.filesArr = filePickerObj.filesArr.filter(item => item !== file);
        
        const dt = new DataTransfer();
        filePickerObj.filesArr.forEach(f => dt.items.add(f));
        filePickerObj.filePicker.files = dt.files;
        
        if (filePickerObj.filesArr.length === 0) {
            filePickerObj.dropZone.classList.remove('hide');
        }
        
        this.renderFileConfirm(filePickerObj);
    }

    updateFileUploadError(files, filePickerObj) {
        if (files[0] && files[0].size >= AjaxUtils.MAX_UPLOAD_SIZE) {
            this.toggleError(filePickerObj.fileDropContainer, true, `Total file upload must not exceed ${AjaxUtils.MAX_UPLOAD_SIZE_MB} MB. Current upload: ${(files[0].size/1048576).toFixed(1)} MB`, false);
        } else {
            this.toggleError(filePickerObj.fileDropContainer, false, "", false);
        }
    }

    registerListeners() {
        this.cumulativeInputs.forEach((input) => {
            input.addEventListener('input', () => {
                this.handleCumulativeInputChanged();
                this.handleProjectSectionInputsErrorClear();
            });

        })
        this.projectSectionInputs.forEach((input) => {
            input.addEventListener('input', () => {
                this.handleProjectSectionInputChanged();
            });
        });

        this.filePickers.forEach((filePicker) => {
            const filePickerObj = {
                filePicker: filePicker,
                fileDropContainer: filePicker.closest('.calculator__field--group'),
                filesArr: new Array()
            };

            filePickerObj.dropZone = filePickerObj.fileDropContainer.querySelector('.file-drop');
            filePickerObj.uploadButton = filePickerObj.fileDropContainer.querySelector('.upload-button');
            filePickerObj.uploadConfirmContainer = filePickerObj.fileDropContainer.querySelector('.confirm-container');

            window.addEventListener('dragover', e => e.preventDefault());
            window.addEventListener('drop', e => e.preventDefault());
            filePickerObj.dropZone.addEventListener('drop', e => this.handleDrop(e, this, filePickerObj));
            filePickerObj.dropZone.addEventListener('dragenter', e => this.handleDragOver(e, filePickerObj));
            filePickerObj.dropZone.addEventListener('dragleave', e => this.handleDragExit(e, filePickerObj));
            filePickerObj.dropZone.addEventListener('dragend', e => e.preventDefault());
            filePickerObj.uploadButton.addEventListener('click', e => {
                e.preventDefault();
                filePickerObj.filePicker.click();
            })
            filePickerObj.filePicker.addEventListener('change', e => this.handleFileReceived(e.target.files, filePickerObj));

            this.filePickerObjects.push(filePickerObj);
        });
    }


}

